import React, { useState, cloneElement } from "react";
import Button from "@material-ui/core/Button/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Typography from "@material-ui/core/Typography";
import {DialogContentText, DialogTitle} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import {Close} from "@material-ui/icons";

const styles = (theme) => ({
  paper: {
    width: "100%",
  },
  modalCloseBtn: {
    position: "absolute",
    top: 10,
    right: 10,
  },
  dialogContent: {
    maxHeight: 300,
    border: `1px solid ${theme.palette.grey["A200"]}`,
    margin: `0 30px`,
    padding: 0,
  },
  viewButton: {
    marginTop: 4,
    fontSize: 12,
  },
});

const GenericHelpModal = (props) => {
  const [open, setOpen] = useState(false);
  const { classes, dialogAnchorComponent } = props;

  const handleOpenModal = () => {
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  if (!dialogAnchorComponent) {
    return null;
  }

  return (
    <React.Fragment>
      {cloneElement(dialogAnchorComponent, { onClick: handleOpenModal })}

      <Dialog open={open}>
        <DialogTitle id="cyhelp-modal-title">
          Help
          <IconButton
            className={classes.modalCloseBtn}
            aria-label="Close"
            onClick={handleCloseModal}
          >
            <Close color="primary" />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <Typography>
              For any queries regarding the Cy website, please email <a href="mailto: cy@investwithcy.com">cy@investwithcy.com</a>.
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} size="small">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default withStyles(styles)(GenericHelpModal);



// WEBPACK FOOTER //
// ./src/components/HelpWidget/components/GenericHelpModal/index.jsx